export default "__VITE_ASSET__9d21df79__"